<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item>
              <a-input placeholder="请输入单据号或备注" v-model="queryParam.kw"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="单据日期">
              <a-range-picker @change="dateChange" :defaultValue="[moment(queryParam.s_date, format), moment(queryParam.e_date, format)]"></a-range-picker>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="客户"
            >
              <a-input-search
                placeholder="请选择客户"
                @change="customerTextChange"
                @search="onCustomerSearch"
                @click="onCustomerSearch"
                v-model="customerName"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="tableSearch">查询</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd">新增</a-button>
      <a-button type="default" icon="reload" @click="reloadTable">刷新</a-button>
    </div>

    <s-table
      size="default"
      ref="table"
      :pageSize=20
      :columns="columns"
      :data="loadData"
      bordered
      rowKey="id"
    >
      <span slot="transType" slot-scope="text, record">
        {{ transType(record.transType) }}
      </span>
      <span slot="relBill" slot-scope="text, record">
        <div v-for="bill in record.relBill" :key="bill.id">
          <router-link :to="{ path: relBillPath(record.transType, bill.id) }">{{bill.billNo}}</router-link>
        </div>
      </span>
      <span slot="billStatus" slot-scope="text, record">{{ billStatus(record.billStatus, record.transType) }}</span>
      <span slot="action" slot-scope="text, record">
        <router-link :to="{ path: '/sales/order/edit/'+record.id }">查看</router-link>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a-popconfirm placement="topLeft" title="确定要删除此销货订单吗?删除后相关收数据将同时删除！" @confirm="deleteConfirm(record.id)" okText="确定" cancelText="取消">
                <a href="#">删除</a>
              </a-popconfirm>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>
    <CustomerModal :visible="customerModalVisible" @handleCancel="customerModalCancel" @handleOk="customerModalOk"></CustomerModal>
  </a-card>
</template>
<script>
import moment from 'moment'
import { TYPE_SALES_BILL_OUT, TYPE_NOT, TYPE_PART, TYPE_ALL, TYPE_SALES_BILL_IN, CODE_FAIL } from '@/store/mutation-types'
import STable from '@/components/table/'
import CustomerModal from '@/components/Customer/Modal'
import { getSalesBillList, deleteSalesBill } from '@/api/bill'

export default {
  components: {
    STable,
    CustomerModal
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: this.$form.createForm(this),
      format: 'YYYY-MM-DD',
      customerModalVisible: false,
      // 查询参数
      queryParam: {
        s_date: '',
        e_date: '',
        contactId: '',
        kw: ''
      },

      customerName: '',
      // 表头
      columns: [
        {
          title: '订单日期',
          dataIndex: 'billDate',
          className: 'text-center'
        },
        {
          title: '订单编号',
          dataIndex: 'billNo',
          className: 'text-center'
        },
        {
          title: '业务类别',
          className: 'text-center',
          scopedSlots: { customRender: 'transType' }
        },
        {
          title: '客户',
          dataIndex: 'customer.name',
          className: 'text-center'
        },
        {
          title: '关联销货单',
          className: 'text-center',
          scopedSlots: { customRender: 'relBill' }
        },
        {
          title: '销售金额',
          className: 'text-right',
          dataIndex: 'totalAmount'
        },
        {
          title: '数量',
          className: 'text-right',
          dataIndex: 'totalQty'
        },
        {
          title: '订单状态',
          className: 'text-center',
          scopedSlots: { customRender: 'billStatus' }
        },
        {
          title: '交货日期',
          className: 'text-center',
          dataIndex: 'deliveryDate'
        },
        {
          title: '备注',
          dataIndex: 'note',
          className: 'text-center'
        },
        {
          title: '操作',
          dataIndex: 'action',
          className: 'text-center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getSalesBillList(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.result
          })
      },

      selectedRowKeys: [],
      selectedRows: []
    }
  },
  created () {
    this.queryParam.s_date = moment().subtract(7, 'days').format(this.format)
    this.queryParam.e_date = moment().format(this.format)
  },
  methods: {
    relBillPath (transType, billId) {
      if (transType === TYPE_SALES_BILL_OUT) {
        return '/sales/invoice/edit/' + billId
      } else {
        return '/sales/recede/edit/' + billId
      }
    },
    moment,
    customerTextChange (e) {
      if (!e.data) {
        this.queryParam.contactId = ''
      }
    },
    customerModalCancel () {
      this.customerModalVisible = false
    },
    customerModalOk (selectedRows) {
      this.customerModalVisible = false
      if (selectedRows.length > 0) {
        const rowData = selectedRows.pop()
        this.queryParam.contactId = rowData.id
        this.customerName = rowData.name
      }
    },
    onCustomerSearch () {
      this.customerModalVisible = true
    },
    dateChange (date, dateString) {
      this.queryParam.s_date = dateString[0]
      this.queryParam.e_date = dateString[1]
    },
    handleAdd () {
      this.$router.push({ name: 'SalesOrder' })
    },

    reloadTable () {
      this.$refs.table.refresh(true)
    },
    tableSearch () {
      this.$refs.table.refresh(true)
    },
    transType (type) {
      return type === TYPE_SALES_BILL_OUT ? '销货' : '退货'
    },
    billStatus (status, transType) {
      switch (transType) {
        case TYPE_SALES_BILL_IN:
          switch (status) {
            case TYPE_NOT:
              return '未入库'

            case TYPE_PART:
              return '部分入库'

            case TYPE_ALL:
              return '全部入库'
          }
          break
        case TYPE_SALES_BILL_OUT:
          switch (status) {
            case TYPE_NOT:
              return '未出库'

            case TYPE_PART:
              return '部分出库'

            case TYPE_ALL:
              return '全部出库'
          }
          break
      }
    },
    deleteConfirm (id) {
      deleteSalesBill({ id: id })
        .then(res => {
          if (res.status === CODE_FAIL) {
            this.$message.error(res.message || '请求出现错误，请稍后再试')
          } else {
            this.$message.success('删除成功')
            this.reloadTable()
          }
        })
    }
  },
  watch: {
  }
}
</script>
<style>

  th.text-right, td.text-right {
    text-align: right !important;
  }
  th.text-center, td.text-center {
    text-align: center !important;
  }
</style>
